import { trackInfraPageWeightView } from "@faire/web-api--source/events/infra/view/pageWeight";
import { getPageWeightInfo } from "./resourceTiming";
import { ResourceTimingCollector } from "./ResourceTimingCollector";
import { truncatePath } from "./truncatePath";
export var trackPageWeight = function(path, pageName, loadType, timeOfLastRouteChange) {
    var entries = ResourceTimingCollector.get().getResourceEntries(timeOfLastRouteChange);
    if (entries === undefined) {
        return;
    }
    var info = getPageWeightInfo(entries);
    trackInfraPageWeightView(JSON.stringify({
        path: truncatePath(path),
        pageName: pageName,
        loadType: loadType
    }), JSON.stringify(info));
};
